
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import getContractorsMultiselectConditions from "@/helpers/getContractorsMultiselectConditions";

import InputRangeFilter from "@/components/filters/InputRangeFilterNew.vue";
import FiltersContainer from "@/components/filters/filters-container.vue";
import UiButton from "@/components/button/ui-button.vue";
import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
import ManagersMultiselect from "@/components/autocompleteMultiselects/ManagersMultiselectNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";

import Roles from "@/entities/Roles";
import ProjectsFiltersQuery from "@/entities/filters/ProjectsFiltersQuery";
import FormDatepicker from "../form/FormDatepickerV2.vue";
import UiButtonMessage from "@/components/button/ui-button-message.vue";

@Component({
  components: {
    UiButton,
    InputRangeFilter,
    FiltersContainer,
    ContractorsMultiselect,
    ManagersMultiselect,
    FormGroup,
    UIButton,
    UiButtonMessage,
    FormDatepicker
  },
})
export default class ProjectCollectionFilters extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly hideManagersFilter!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideContractorsFilter!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly hideBudgetFilter!: boolean;
  @Prop({ type: String, default: undefined }) readonly currentUserId?: string;
  @Prop({ type: String, default: undefined })
  readonly currentUserRole?: string;
  @Prop({ type: Object, required: true })
  readonly filters!: ProjectsFiltersQuery;

  title: string = "";
  contractorsIds: string[] = [];
  managersIds: string[] = [];
  createdAt: string = "";
  location: string = "";

  get propToWatch(): String {
    return JSON.stringify([
      this.title,
      this.createdAt,
      this.contractorsIds,
      this.location,
      this.managersIds,
    ]);
  }

  get contractorsMultiselectConditions(): Object | undefined {
    return getContractorsMultiselectConditions(this.currentUserRole);
  }

  get managersMultiselectConditions(): Object | undefined {
    if (this.currentUserRole !== Roles.CONTRACTOR) {
      return {};
    }

    return {
      projects: {
        project_activities: {
          contractor: {
            user_id: {
              _eq: this.currentUserId,
            },
          },
        },
      },
    };
  }

  @Watch("filters", { immediate: true })
  updateFiltersValues(): void {
    this.title = this.filters.title;
    this.contractorsIds = this.filters.contractors;
    this.managersIds = this.filters.managers;
    this.createdAt = this.filters.createdAt;
    this.location = this.filters.location;
  }

  @Watch("propToWatch")
  handlePropToWatchChange(): void {
    const dateFormat = "YYYY-MM-DD";
    this.$emit("filtersChanged", {
      createdAt: this.createdAt
        ? this.$moment(this.createdAt).format(dateFormat)
        : "",
      title: this.title,
      contractors: this.contractorsIds,
      managers: this.managersIds,
      location: this.location,
    });
  }

  handleReset(): void {
    this.$emit("filtersReset");
  }
}
